
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PartnersHeader from "@/components/partners/PartnersHeader";
import PartnershipValues from "@/components/partners/PartnershipValues";
import PartnersGrid from "@/components/partners/PartnersGrid";
import PartnershipImpact from "@/components/partners/PartnershipImpact";
import PartnershipCTA from "@/components/partners/PartnershipCTA";

const Partners = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen">
        <PartnersHeader />
        <div className="bg-gradient-to-br from-sky-blue/20 via-white to-bobo-green/20">
          <PartnershipValues />
          <PartnersGrid />
          <PartnershipImpact />
        </div>
        <PartnershipCTA />
      </div>
      <Footer />
    </>
  );
};

export default Partners;
